import { writable, get } from 'svelte/store';

class Store {
  city = writable({});
  other = writable({});
  cities = writable([]);
  alert = writable(null);
  search = writable(false);
  burger = writable(false);
  modal = writable(-1);
}

const store = new Store();

store.burger.subscribe(v => {
  if (v && get(store.search)) store.search.set(false);
  return v;
});

store.search.subscribe(v => {
  if (v && get(store.burger)) store.burger.set(false);
  return v;
});

export default store;
